module.exports = __webpack_public_path__ + "img/add-hl.cf013235.png";